var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgRejectDayOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2203_62403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3 14.875H3.29999C3.29999 11.5 4.48415 11.5 6.45832 11.5C10.8 11.5 7.46665 7.675 7.46665 5.83333C7.46665 4.94928 7.81784 4.10143 8.44296 3.47631C9.06809 2.85119 9.91593 2.5 10.8 2.5C11.684 2.5 12.5319 2.85119 13.157 3.47631C13.7821 4.10143 14.1333 4.94928 14.1333 5.83333C14.1333 7.675 10.8 11.5 15.1417 11.5C17.1158 11.5 18.3 11.5 18.3 14.875Z",
    stroke: "#002244",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96664 17.5H16.6333",
    stroke: "#002244",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2203_62403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.965 19.2492C21.1855 19.0286 21.3 18.7484 21.3 18.4377C21.3 18.127 21.1855 17.8468 20.965 17.6262L19.3387 16L20.965 14.3738C21.1855 14.1532 21.3 13.873 21.3 13.5623C21.3 13.2516 21.1855 12.9714 20.965 12.7508L20.0492 11.835C19.8286 11.6145 19.5484 11.5 19.2377 11.5C18.927 11.5 18.6468 11.6145 18.4262 11.835L16.8 13.4612L15.1737 11.835C14.9532 11.6145 14.6729 11.5 14.3623 11.5C14.0516 11.5 13.7713 11.6145 13.5508 11.835L12.635 12.7508C12.4145 12.9714 12.3 13.2516 12.3 13.5623C12.3 13.873 12.4145 14.1532 12.635 14.3738L14.2612 16L12.635 17.6262C12.4145 17.8468 12.3 18.127 12.3 18.4377C12.3 18.7484 12.4145 19.0286 12.635 19.2492L13.5508 20.165C13.7713 20.3855 14.0516 20.5 14.3623 20.5C14.6729 20.5 14.9532 20.3855 15.1737 20.165L16.8 18.5388L18.4262 20.165C18.6468 20.3855 18.927 20.5 19.2377 20.5C19.5484 20.5 19.8286 20.3855 20.0492 20.165L20.965 19.2492Z",
    fill: "#EA2727",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2203_62403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.799988)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2203_62403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(9.79999 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgRejectDayOff);
export default __webpack_public_path__ + "static/media/svg_reject_day_off.7642dbb15755f0edcac3522a7bf16353.svg";
export { ForwardRef as ReactComponent };